import { useParams } from "react-router-dom";
import { PathParams, RoutingPath } from "../../../../routes/routing-path";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { Button } from "../../../ui/button/button";
import { push } from "connected-react-router";
import iconDelete from '../../../../assets/img/icon/delete.svg';
import iconStar from '../../../../assets/img/icon/star.svg';
import { TrimEditableImage } from "../../../../trim-editor/manager/image-edit/trim.editable-image";
import { TextArea } from "../../../ui/textarea/textarea";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PrintItemDataEntity, PrintProductDataEntity, PrintProductImageDataEntity } from "../../../../models/sift/json/print-model";
import { TrimThumbManager } from "../../../../trim-editor/manager/thumb/trim.thumb.manager";
import { PrintImagesDataEntity } from "../../../../api/sift/front/api-print-image";
import { apiActions } from "../../../../slices/api-slice";
import { ApiImagesGetOne } from "../../../../api/front/images/api-images";
import { dialogActions } from "../../../dialog/slice/dialog-slice";
import { SaveFavoriteBrandForPrint } from "../../../dialog/unique/save-favorite-brand-for-print";
import { DateFormatter } from '../../../../utilities/date-formatter';

const SliderImage = (props: {
  id: string;
  count: number;
  trimmingStatus: 1 | 2 | 3;
  datePrint: boolean;
  rotate: '0' | '1';
  thumbId?: string;
  image: TrimEditableImage | undefined;
  imagesLength: number,
  thumbImages: PrintImagesDataEntity[],
}) => {
  const {
    id,
    count,
    trimmingStatus,
    datePrint,
    rotate,
    thumbId,
    imagesLength,
    thumbImages,
    image,
  } = props;
  const dispatch = useAppDispatch();
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const [thumbData, setThumbData] = useState('');
  const src = useMemo(() => {
    if (thumbId && imagesLength) {
      return thumbData;
    }
    return image?.thumbnailBase64;
  }, [image, thumbData, thumbId, imagesLength]);

  useEffect(() => {
    if (thumbId) {
      const target = thumbImages?.find((v) => v.id === thumbId);
      if (!target) {
        if (thumbImages?.length) {
          console.warn('指定のサムネイル情報が見つかりません。');
        }
        return;
      }
      dispatch(apiActions.run(
        new ApiImagesGetOne({
          kijshopCd,
          path: `${target.path}/${target.filename}`,
        }),
        {
          onSuccess: (blob: Blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              setThumbData(reader.result as string)
            }
            reader.readAsDataURL(blob);
          },
          onError: (blob: Blob) => {
            // resolve(blob);
          },
        },

      ))
    }

  }, []);

  return (
    <div className="slick_img">
    {src ? (
      <img alt="" src={src} />
    ) : (
      <div
        className="loading_popup__dots"
        style={{ fontSize: 6, animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
      />

    )}
  </div>

  )
}

const ImagesSlider = (props: {
  images: {
    id: string;
    count: number;
    trimmingStatus: 1 | 2 | 3;
    datePrint: boolean;
    rotate: '0' | '1';
    thumbId?: string;
    image: TrimEditableImage | undefined;
  }[],
  onClose: () => void,
  thumbImages: PrintImagesDataEntity[],
}) => {
  const [viewLine, setViewLine] = useState(false);
  return (
    <div className="preview_overlay" onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      props.onClose();
    }}>
      <div className="preview_overlay__cnt" onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
        <div className="preview_overlay__header">
          <Button
            label="中心線表示 ON/OFF"
            size="sm"
            onClick={() => {
              setViewLine(!viewLine);
            }}
          />
        </div>
        <hr/>
        <div className="slick_wrap">
          <Slider

            {...{
              arrows: true,
              useCSS: true,
              initialSlide: 0,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
            }}
          >
            {props.images.map((v) => (
              <SliderImage
                key={v.id}
                imagesLength={props?.images?.length ?? 0}
                thumbImages={props.thumbImages}
                {...v}
              />
            ))}
          </Slider>
          {!!viewLine && (
            <div className="center_line" />
          )}
        </div>
      </div>
    </div>
  )
}

const ThumbCard = (props: {
  image: TrimEditableImage | undefined;
  item: PrintItemDataEntity,
  thumbData?: PrintImagesDataEntity,
} & PrintProductImageDataEntity) => {
  const {
    image,
    item,
    datePrint,
    ...structureData
  } = props;
  const dispatch = useAppDispatch();
  const {
    kijshopCd,
    shopOrderId,
  } = useParams<PathParams>();
  const [thumbSrc, setThumbSrc] = useState('');
  const [src, setSrc] = useState('');
  const viewSrc = useMemo(() => {
    if (!props.thumbId) return src;
    return thumbSrc;
  }, [
    thumbSrc,
    props.thumbId,
    src,
  ]);
  const viewDate = useMemo(() => {
    if (datePrint && !image?.exif.createDate) {
      return '日付情報なし';
    }
    if (datePrint && image?.exif.createDate) {
      return DateFormatter.date2str(image?.exif.createDate, 'YYYYMMDD', '/');
    }
    return undefined;
  }, [datePrint, image]);
  const createThumb = useCallback(() => {
      if (!image) return;
      const mng = new TrimThumbManager();
      const directFlg = !Number(structureData.rotate) ? '1' : '2';
      mng.makeThumbOutCanvas({
        kijshopCd,
        shopOrderId,
        orderId: item.id,
        item: item,
        editableImgId: image.id,
        directFlg,
      }).then((res) => {
        if (res) {
          setSrc(res);
        }
      })
  }, [structureData]);
  useEffect(() => {
    if (!src && image) {
      createThumb();
    }
  }, [image]);

    useEffect(() => {
      if (props.thumbData) {
        dispatch(apiActions.run(
          new ApiImagesGetOne({
            kijshopCd,
            path: `${props.thumbData.path}/${props.thumbData.filename}`,
          }),
          {
            onSuccess: (blob: Blob) => {
              const reader = new FileReader();
              reader.onload = () => {
                setThumbSrc(reader.result as string)
              }
              reader.readAsDataURL(blob);
            },
            onError: (blob: Blob) => {
              // resolve(blob);
            },
          },
        ))
      }
    }, [props.thumbData]);

  return (
    <>
      {viewSrc ? (
        <img alt="" src={viewSrc} />
      ) : (
        <div
          className="loading_popup__dots"
          style={{ fontSize: 6, animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
        />

      )}
    </>
  )
}

type Props = {
  id: string,
  onDelete: (id: string) => void,
  images: TrimEditableImage[],
  thumbImages:  PrintImagesDataEntity[],
  memo: {
    value: string,
    onChange: (id: string, value: string) => void,
    blur: () => void,
  },
  ordered: boolean,
  productData?: PrintProductDataEntity,
}

export const PrintPreparationImagesList = (props: Props) => {
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const {
    id,
    onDelete,
    images,
    memo,
    thumbImages,
    ordered,
    productData,
  } = props;
  const dispatch = useAppDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const {
    data,
  } = useAppSelector((state )=> ({
    data: state.print.printShopOrderData[shopOrderId]?.meta,
  }));
  const selectItem = useMemo(() => {
    return data?.item?.[id];
  }, [id, data]);

  const viewImages = useMemo(() => {
    if (!selectItem) return [];
    return selectItem.images.filter((v) => v.count)
    .map((v) => {
      const target = images.find((img) => img.id === v.id);
      return {
        image: target,
        ...v,
      }
    });
  }, [
    images,
    selectItem,
  ]);

  const handleClickEdit = useCallback(() => {
    if (!selectItem) return;
    dispatch(push(`${RoutingPath.cnv.printOrderSelectImage({ kijshopCd, shopOrderId })}?t=${selectItem.id}`));
  }, [dispatch]);

  const handleClickFavorite = useCallback(() => {
    dispatch(dialogActions.push({
      title: 'お気に入り商品保存',
      element: <SaveFavoriteBrandForPrint
        kijshopCd={kijshopCd}
        productData={productData}
      />,
    }));
  }, [
    dispatch,
    kijshopCd,
    productData,
  ]);
  const disabledMemo = useMemo(() => {
    const isToneCollect = data?.toneCorrection.filter((v) => {
      return v.value && viewImages.find((v2) => v2.id === v.id);
    })
    return ordered
      || (
        !isToneCollect?.length
        && !viewImages.find((v) => v.trimmingStatus === 3)
      )
  }, [
    ordered,
    viewImages,
    data,
  ]);
  if (!selectItem) return <></>;
  return (
    <>
      <div className="order_preparation__body__item_images">
        <div className="order_preparation__body__item_images__header">
          <div className="order_preparation__body__item_images__header__img_count">
            <span>プリント枚数：</span>
            <span>{selectItem.images.reduce((a, b) => a + b.count, 0)}</span>
            <span>枚</span>
          </div>
          <div className="order_preparation__body__item_images__button_box">
            <Button
              label="プレビュー"
              onClick={() => setOpenPreview(true)}
              className="btn_edit"
              size="sm"
              color="light"
            />
            <Button
              label="編集"
              onClick={() => handleClickEdit()}
              className="btn_edit"
              size="sm"
              disabled={ordered}
            />
            <Button
              size="sm"
              color="light"
              icon={<img src={iconStar} alt="" />}
              onClick={() => handleClickFavorite()}
              className="btn_favorite"
            />
            <Button
              size="sm"
              color="light"
              icon={<img src={iconDelete} alt="" />}
              onClick={() => onDelete(selectItem.id)}
              style={{ border: 'none' }}
              disabled={ordered}
            />
          </div>
        </div>
        <div className="order_preparation__body__item_images__memo">
          <div className="order_preparation__body__item_images__memo__annotation">
            ラボへの要望欄(最大50文字) ※色調やトリミングに関する要望がある場合は、各商材ごとにご記入ください
          </div>
          <TextArea
            value={memo.value}
            onChange={(e) => memo.onChange(id, e.target.value)}
            onBlur={() => memo.blur()}
            limit={50}
            disabled={disabledMemo}
          />
        </div>
        <div className="order_preparation__body__item_images__list">
          {viewImages.map((v) => (
            <div key={v.id}className="order_preparation__body__item_images__list__child">
              <div className="order_preparation__body__item_images__list__child__wrap">
                <div className="thumbnail_wrap">
                  <div className="thumbnail">
                    <div className="thumbnail__thumb">
                      <div className="base_image">
                        <ThumbCard
                          {...{ ...v, item: selectItem }}
                          thumbData={props.thumbImages?.find((thumb) => thumb.id === v.thumbId)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="order_preparation__body__item_images__list__child__info_box">
                <div className="order_preparation__body__item_images__list__child__info_box__name">{v.image?.name ?? ''}</div>
                <div className="order_preparation__body__item_images__list__child__info_box__count">
                  <div>数量</div>
                  <div>{v.count || 0}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      { openPreview && (
        <ImagesSlider
          images={viewImages}
          thumbImages={thumbImages}
          onClose={() => setOpenPreview(false)}
        />
      )}
    </>
  )
}
